import React from 'react';

// Loading spinner for Audio page
export const AudioLoadingFallback = () => (
  <div 
    className="fixed inset-0 z-[10000] flex flex-col items-center justify-center"
    style={{ backgroundColor: '#0a0a0a' }}
    data-testid="audio-loading-screen"
  >
    <div className="relative mb-8">
      <div 
        className="w-20 h-20 rounded-full"
        style={{
          border: '4px solid rgba(230, 184, 0, 0.2)',
          borderTopColor: '#E6B800',
          animation: 'spin 1s linear infinite'
        }}
      />
    </div>
    <h2 className="text-2xl font-serif text-[#E6B800] mb-3" style={{ fontFamily: 'Cinzel, serif' }}>
      Se încarcă Arhivele Audio...
    </h2>
    <p className="text-[#999] text-base">Pregătim episoadele</p>
    
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

// Loading skeleton for Explorer/Map page
export const MapLoadingFallback = () => (
  <div 
    className="fixed inset-0 z-[10000] flex flex-col items-center justify-center"
    style={{ backgroundColor: '#f5f3ef' }}
    data-testid="explorer-loading-screen"
  >
    <div className="text-center">
      {/* Animated spinner */}
      <div className="relative w-16 h-16 mx-auto mb-6">
        <div className="absolute inset-0 rounded-full border-4 border-amber-100"></div>
        <div 
          className="absolute inset-0 rounded-full border-4 border-transparent border-t-amber-500"
          style={{ animation: 'spin 1s linear infinite' }}
        ></div>
      </div>
      <h2 className="text-xl font-serif text-gray-700 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>
        Se încarcă Harta Istorică...
      </h2>
      <p className="text-sm text-gray-500">Pregătim datele geografice</p>
      
      {/* Map skeleton preview */}
      <div className="mt-8 w-64 h-40 mx-auto bg-gray-200 rounded-lg overflow-hidden relative">
        <div 
          className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200"
          style={{
            animation: 'shimmer 1.5s infinite',
            backgroundSize: '200% 100%'
          }}
        />
        <div className="absolute bottom-3 left-3 right-3 h-8 bg-gray-300 rounded opacity-50"></div>
      </div>
    </div>
    
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
      @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
    `}</style>
  </div>
);

export default { AudioLoadingFallback, MapLoadingFallback };
